module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l6qdl"))).then(() => parcelRequire('f4eak'));